import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const removeUserPromoCode = payload =>
  call(websocketFetch, 'remove_user_promo_code', payload);
